import React from 'react'
import ReactDOM from 'react-dom'
import { CookiesProvider } from 'react-cookie'
import debug from 'debug'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { loadableReady } from '@loadable/component'
import { ThemeProvider } from 'styled-components'
import { VocabProvider, ArgosVocab, HabitatVocab } from '@sainsburys-tech/bolt-vocab-provider'
import { AddToWishlist, Themes } from '@sainsburys-tech/bolt'
import initClientOnlyRequests from './utils/initClientOnlyRequests'
import Application from './containers/Application'
import config from './config/index'
import getStore from './store'
import reportCustomAttributes from './utils/reportCustomAttributes'

import initHookLogic from './utils/initHookLogic'

const appDebug = debug('App')

const isRealProduction =
  window.location.hostname.toLowerCase().indexOf('argos.co.uk') !== -1 && process.env.NODE_ENV === 'production'

if (isRealProduction) {
  debug.disable()
} else {
  debug.enable('App')
}

const getBrandTheme = () => {
  return window.BRAND === 'argos' ? Themes.ArgosTheme : Themes.HabitatTheme
}
const getBrandVocab = () => {
  return window.BRAND === 'argos' ? ArgosVocab : HabitatVocab
}

// Register Service Worker
if (window.BRAND === 'argos' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', {
        scope: '/'
      })
      .then(registration => {
        console.log('SW registered: ', registration)
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError)
      })
  })
}

const Fetchr = require('fetchr')

const fetchr = new Fetchr({
  xhrPath: config.xhrPath, // Path for XHR to be served from
  xhrTimeout: config.xhrTimeout
})

appDebug('Rehydrating...')

const reduxStore = getStore()

reduxStore.dispatch(AddToWishlist.getUserDetails())

const context = {
  service: fetchr,
  reduxStore
}

if (window.BRAND === 'argos') {
  try {
    initHookLogic(context)
  } catch (e) {
    throw new Error(e)
  }
}

initClientOnlyRequests(context)

loadableReady(() => {
  ReactDOM.hydrate(
    <Provider store={reduxStore}>
      <BrowserRouter>
        <CookiesProvider>
          <ThemeProvider theme={getBrandTheme()}>
            <VocabProvider vocab={getBrandVocab()}>
              <Application brand={window.BRAND} />
            </VocabProvider>
          </ThemeProvider>
        </CookiesProvider>
      </BrowserRouter>
    </Provider>,
    document.getElementById('app'),
    () => {
      initClientOnlyRequests(context)
      appDebug('React Rendered')
      reportCustomAttributes()
    }
  )
})
